import { initializeApp } from "firebase/app";
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail,
  sendEmailVerification, updatePassword, signOut,
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore, query, getDocs, collection, where, addDoc, } from "firebase/firestore";
import { client, getLoginSupervisorAccessRights } from "../../store/action/RemoteActionSupervisor";
//import ReactObserver from 'react-event-observer';
import mitt from "mitt";
//import { getAnalytics } from "firebase/analytics";
//import QRCode from 'qrcode';

let SERVER_API_URL = process.env.REACT_APP_SERVER_URL_API;
const firebaseConfig = {
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASEURL,
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID
  //measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENTID
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
//const emitter = mitt();
export const firebaseObserver = mitt();
//const googleProvider = new GoogleAuthProvider();
//export const firebaseObserver = ReactObserver();
//const analytics = getAnalytics();

const getUserDetails = async (uid) => {
  const q = await query(collection(db, "adminusers"), where("uid", "==", uid));
  const data = await getDocs(q);
  return data;
};

//auth.onAuthStateChanged(function (user) {
//  firebaseObserver.publish("authStateChanged", loggedIn())
//});
auth.onAuthStateChanged(() => {
  firebaseObserver.emit("authStateChanged", loggedIn());
});

function loggedIn() {
  return !!auth.currentUser;
};

const setSupervisorLoginSuccess = () => {
  localStorage.setItem("isSupervisorLogin", 1);
};

const isSupervisorLoginSuccess = () => {
  let sLoginFlag = localStorage.getItem("isSupervisorLogin");
  if (sLoginFlag && parseInt(sLoginFlag) === 1) {
    return true;
  }
  return false;
};

const registerWithEmailAndPassword = async (firstName, lastName, adminRole, email, password, createdByUser, isFromSignup) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await sendEmailVerification(user)
      .then(() => {
        console.log("Email verification sent!");
      });

    let token = localStorage.getItem("supervisortoken");
    if (isFromSignup) {
      token = await auth?.currentUser?.getIdToken(true);
      localStorage.setItem("supervisortoken", token);
      createdByUser = user.uid;
    }
    if (token) {
      let result = await client(token).post(`${SERVER_API_URL}/supervisor/new`, {
        VfaspID: process.env.REACT_APP_VFASP_CODE,
        AdminID: createdByUser,
        NewAdminID: user.uid,
        MailID: email,
        FirstName: firstName,
        LastName: lastName,
        AdminRole: adminRole
      });
      if (result.status === 200 && result.data?.AuthenticationUrl && result.data?.OtpSecret) {
        await addDoc(collection(db, "adminusers"), {
          uid: user.uid,
          name: firstName + ' ' + lastName,
          authProvider: "local",
          secret: result.data.OtpSecret,
          email: email,
        });
        return result.data.AuthenticationUrl;
      }
    }

    return null;
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    let nLoginResponse = 0;
    await signInWithEmailAndPassword(auth, email, password).then(async (result) => {
      if (!result?.user?.emailVerified) {
        await sendEmailVerification(result?.user)
          .then(() => {
            logout();
            console.log("Email verification sent!");
          });
        return false;
      }

      const token = await auth?.currentUser?.getIdToken(true);
      const uid = result?.user?.uid;
      if (token && uid) {
        //Verify user registered in AGATHA DB
        let response = await client(token).post(`${SERVER_API_URL}/supervisor/login`, {
          VfaspID: process.env.REACT_APP_VFASP_CODE,
          AdminID: uid
        });
        if (response.status !== 200) {
          alert("Server Error");
          return false;
        }
        if (!response.data || response.data.length === 0 || !response.data[0]) {
          alert("Supervisor not registered");
        } else if (response.data.length > 0) {
          let loginSupervisor = response.data[0];
          if (loginSupervisor.LoginResponse === 5) {
            alert("Login is Disabled.");
          } else if (loginSupervisor.AdminID !== uid) {
            alert("Supervisor not registered");
          } else {
            localStorage.setItem("supervisortoken", token);
            localStorage.setItem("supervisorid", uid);
            localStorage.setItem("showQRCode", loginSupervisor.IsShowQRCode);
            if (loginSupervisor.IsMFAEnabled === 1) {
              localStorage.setItem("otpSecret", loginSupervisor.OtpSecret);
              if (loginSupervisor.IsShowQRCode === 1) {
                localStorage.setItem("authenticationUrl", loginSupervisor.AuthenticationUrl);
              }
              if (loginSupervisor.LoginResponse === 1) {
                nLoginResponse = 2;
              } else if (loginSupervisor.LoginResponse === 2) {
                nLoginResponse = 12;
              }
            } else {
              if (loginSupervisor.LoginResponse === 1) {
                setSupervisorLoginSuccess();
                await getLoginSupervisorAccessRights();
                nLoginResponse = 1;
              } else if (loginSupervisor.LoginResponse === 2) {
                nLoginResponse = 11;
              }
            }
            setTimeout(() => logout(), 600000);
          }
        }
      } else {
        logout();
      }
    });

    return nLoginResponse;
  } catch (err) {
    console.error(err);
    logout();
    alert(err.message);
    return 0;
  }
};

const validateOTP = async (otp, token, adminId) => {
  try {
    if (otp && token && adminId) {
      let response = await client(token).post(`${SERVER_API_URL}/supervisor/MFAlogin`, {
        VfaspID: process.env.REACT_APP_VFASP_CODE,
        AdminID: adminId,
        OTP: otp
      });
      if (response.status === 200 && response.data.LoginResponse === 1) {
        localStorage.setItem("supervisortoken", token);
        localStorage.setItem("supervisorid", adminId);
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (ex) {
    console.error(ex);
    return false;
  }
};
/*const validateOTP = async (otp, otpSecret, sToken, sAdminID) => {
  try {
    var isValid = await authenticator.check(otp, otpSecret);
    if (isValid) {
      localStorage.setItem("supervisortoken", sToken);
      localStorage.setItem("supervisorid", sAdminID);
      if (sToken && sAdminID) {
        await client(sToken).post(`${SERVER_API_URL}/supervisor/MFAlogin`, {
          VfaspID: process.env.REACT_APP_VFASP_CODE,
          AdminID: sAdminID
        });
      }
    }
    return isValid;
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};*/

const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const updateSupervisorPassword = async (newPassword) => {
  let bRet = false;
  let token = localStorage.getItem("supervisortoken");
  let adminId = localStorage.getItem("supervisorid");

  await updatePassword(auth?.currentUser, newPassword)
    .then(async () => {
      setSupervisorLoginSuccess();
      await client(token).post(`${SERVER_API_URL}/supervisor/password/update`, {
        VfaspID: process.env.REACT_APP_VFASP_CODE,
        AdminID: adminId
      });
      bRet = true;
    }).catch((error) => {
      console.log(error);
    });
  return bRet;
};

const userLogout = async (logoutType) => {
  let token = localStorage.getItem("supervisortoken");
  let adminId = localStorage.getItem("supervisorid");
  if (token && adminId) {
    await client(token).post(`${SERVER_API_URL}/supervisor/logout`, {
      VfaspID: process.env.REACT_APP_VFASP_CODE,
      AdminID: adminId,
      LogoutType: logoutType
    });
  }
  logout();
};

const logout = () => {
  console.log('logout called');
  localStorage.removeItem("supervisortoken");
  localStorage.removeItem("supervisorid");
  localStorage.removeItem("AGATHAMenuState");
  localStorage.removeItem("showQRCode");
  localStorage.removeItem("authenticationUrl");
  localStorage.removeItem("SupervisorAccessRights")
  localStorage.removeItem("isSupervisorLogin");
  signOut(auth);
};

const resetTimout = () => {
  let timerId = localStorage.getItem("logouttimerid");
  if (timerId) {
    clearTimeout(timerId);
    const retVal = setTimeout(() => logout(), 600000);
    localStorage.setItem("logouttimerid", retVal);
  }
};

export {
  auth,
  db,
  storage,
  loggedIn,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  updateSupervisorPassword,
  logout,
  userLogout,
  setSupervisorLoginSuccess,
  resetTimout,
  validateOTP,
  isSupervisorLoginSuccess,
  getUserDetails
};